export const ConfigGoogleAnanlytic = async (id) => {
  let googletagmanager = document.createElement("script");
  googletagmanager.async = true;
  googletagmanager.setAttribute(
    "src",
    "https://www.googletagmanager.com/gtag/js?id=" + id
  );
  document.head.appendChild(googletagmanager);

  var code = document.createElement("script");
  code.text =
    'window.dataLayer = window.dataLayer || [];\r\n    function gtag() {\r\n      dataLayer.push(arguments);\r\n    }\r\n    gtag("js", new Date());\r\n    gtag("config","' +
    id +
    '");';
  document.head.appendChild(code);
};
